module.exports = __webpack_public_path__ + "7aa83501b82b6450124c3d15db63fbb2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-26.png
// module id = 2106
// module chunks = 0